import { useQuery } from "@tanstack/react-query";
import { getTicketStatuts } from "../../api/TICKET/ticketMeta";

export const useTicketStatuts = () =>
  useQuery({
    queryKey: ["ticket-statuts"],
    queryFn: getTicketStatuts,
    staleTime: 4 * 60 * 60 * 1000,
  });
